import React from 'react';
import { useIntl } from 'react-intl';
import backgroundImg from '@whitelabel/media/images/404-background.jpg';
import NavBar from '../../containers/layout/NavBar';
import { StyledHeroBlock } from '../../containers/pages/ErrorPage/styles';
import messages from '../../containers/pages/ErrorPage//messages';
import { StyledLayout } from './styled';

interface IErrorPageProps {
  title?: string;
  leadText?: string;
  button: {
    label: string;
    link?: string;
    onClick?: () => void;
  };
}
const ErrorPage = ({ title: titleProp, leadText: leadTextProp, button }: IErrorPageProps): JSX.Element => {
  const intl = useIntl();
  const title = titleProp || intl.formatMessage(messages.generalErrorTitle);
  const leadText = leadTextProp || intl.formatMessage(messages.generalErrorText);
  return (
    <StyledLayout navBar={<NavBar items={[]} size="lg" hideGlobalNav />} hideFooterNav spacing="lg">
      <StyledHeroBlock
        title={title}
        leadText={leadText}
        backgroundImage={{ file: backgroundImg }}
        ctaOptions={[
          {
            type: 'button',
            value: {
              buttons: [{ text: button.label, link: button.link || '#', onClick: button.onClick }],
            },
          },
        ]}
      />
    </StyledLayout>
  );
};

export default ErrorPage;
